<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";   
import apigeneric from "@/helpers/apigeneric";
import Loader from "@/components/widgets/loader";
import Banner from "../components/banner";

export default {
  page: {
    title: process.env.VUE_APP_NAME,
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    Loader,
    Banner

  },
  mixins: [ apigeneric],
  data() {
    return {
      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
      title: this.$t('StrAnasayfa.Title'),
      NewsData:{},
      NewsTitleDescription: {},
      NewsTitle: {},
      ReadMoreValue: {},
      LangId: this.$route.params.LangId,
      items: [
         
        {
          text: this.$t('StrAnasayfa.Title'),
          active: true,
        },
      ],  
      fetchingStats: true,  
    };
  }, 
  methods: { 
    getFirstImage(gallery) {
      if (gallery) {
        return gallery.split(',')[0].trim();
      }
      return '';
    },
    Get(){
      if(this.LangId=="tr" || this.LangId== null){
        this.ActionsFilterGet({
        Service: "News",
        Page: this.Page,
        Filter:
       "&Newstype=2&Websiteid="+window.$cookies.get("ecampuswebsite"),
      }).then((res) => {
        this.NewsData = res.Data; 
            this.Page.PageDataSize = res.TotalCount;
      });
    }else{
      this.ActionsFilterGet({
        Service: "languages",
        Page: this.Page,
        Filter:
       "&shortlangtitle="+ this.LangId
      }).then((res) => {
        for( let LangData in res.Data){
          this.ActionsFilterGet({
        Service: "newstranslations",
        Page: this.Page,
        Filter: "&Langid="+ res.Data[LangData].Id
      }).then((res) => {
        this.NewsData = res.Data;
        this.Page.PageDataSize = res.TotalCount;
        if(res.TotalCount == 0){
              localStorage.setItem("lang", "tr");
              window.location.reload();
              
            }
        
      });
         }
        
      });
     
    }


    this.ActionsFilterGet({
        Service: "languages",
        Page: this.Page,
        Filter:
          "&shortlangtitle=" + this.LangId
      }).then((res) => {
        for (let LangData in res.Data) {
          this.ActionsFilterGet({
            Service: "LanguagereSources",
            Page: this.Page,
            Filter: "&Langid=" + res.Data[LangData].Id + "&Resourceid=0d5e3dfc-5021-466e-9385-e05926007b30"
          }).then((res) => {
            this.NewsTitle = res.Data;
            if (res.TotalCount == 0) {
              localStorage.setItem("lang", "tr");
              window.location.reload();
            }
          });
        }
      });


      this.ActionsFilterGet({
        Service: "languages",
        Page: this.Page,
        Filter:
          "&shortlangtitle=" + this.LangId
      }).then((res) => {
        for (let LangData in res.Data) {
          this.ActionsFilterGet({
            Service: "LanguagereSources",
            Page: this.Page,
            Filter: "&Langid=" + res.Data[LangData].Id + "&Resourceid=717cda32-6f7d-42a8-9c26-97ad3e5c0aed"
          }).then((res) => {
            this.NewsTitleDescription = res.Data;
            if (res.TotalCount == 0) {
              localStorage.setItem("lang", "tr");
              window.location.reload();
            }
          });
        }
      });

      this.ActionsFilterGet({
        Service: "languages",
        Page: this.Page,
        Filter:
          "&shortlangtitle=" + this.LangId
      }).then((res) => {
        for (let LangData in res.Data) {
          this.ActionsFilterGet({
            Service: "LanguagereSources",
            Page: this.Page,
            Filter: "&Langid=" + res.Data[LangData].Id + "&Resourceid=878b315b-fa05-41b1-9cc5-4c480effbf65"
          }).then((res) => {
            this.ReadMoreValue = res.Data;
            if (res.TotalCount == 0) {
              localStorage.setItem("lang", "tr");
              window.location.reload();
            }
          });
        }
      });
    }
  },
};
</script>

<template>
 <Loader>
  <Layout> 
      <Banner />
     
<section>
        <div class="home-news">
            <div class="title c-flex flex-column">
                <h3>{{NewsTitle[0].Resourcevalue}}</h3>
                <p>{{NewsTitleDescription[0].Resourcevalue}}</p> 
            </div> 
            <div class="container">
                    <div class="row">
                          <div
            class="col-md-4 c-flex"
            v-for="(Data, index) in NewsData"
            :key="index"
          >
            <div class="card col-md-12">
              <img
                :src="$config.FILES_URL + 'web/' + getFirstImage(Data.Imagegallery)"
                class="card-img-top"
                alt=""
              />
              <div class="card-body">
                <h5 class="card-date">{{ Data.Startdate | formatDateTime }}</h5>
                <h5 class="card-title mt-3">
                  {{ Data.Title }}
                </h5>
                <p class="card-text">
                  <span v-html="Data.Description"></span><br/>
                </p>
                <a :href="'/NewsDetail/'+ LangId + '/'+ Data.Title.toLowerCase()
                                    .replace(/I|İ/gi, 'i')
                                    .replace(/Ğ|ğ/gi, 'g')
                                    .replace(/Ç|ç|ğ/gi, 'c')
                                    .replace(/\s+/g, '-')
                                    .replace(/&/g, `-and-`)
                                    .replace(/--/g, `-`) + '/'+ Data.Id" class="card-link"
                  >{{ReadMoreValue[0].Resourcevalue}} →</a
                >
               
              </div>
            </div>
          </div>
                      </div>
            </div>
            <b-pagination
                class="pagination pagination-rounded justify-content-end mb-2"
                v-model="DefaultPage"
                :total-rows="Page.PageDataSize"
                :per-page="Page.PageSize"
                aria-controls="my-table"
                @input="ChangePage(DefaultPage)"
              >
              </b-pagination>
        </div>
    </section>



     
  
  </Layout>
  </Loader>
</template>
